module.exports = __webpack_public_path__ + "static/img/1.0956215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/cpzl/1.jpg
// module id = JNoH
// module chunks = 0